import ColorSwatch from './ColorSwatch';
export default ColorSwatch;